import React from 'react';

export const ChevronRightLarge: React.FC<{color: string}> = ({color}) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M7.50002 16.6667L14.1667 10L7.50002 3.33335" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
  </svg>
);
